import React from "react";
import { formatMessageFragment } from '@prezly/theme-kit-intl';
export function BaseFormattedMessage(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, formatMessageFragment(props.locale, props.for, props.messages, props.values));
}